import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import { TPVOrderData } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { SetEditDeleteModalTy, UseEditDeleteModalProps } from '../../../../../../../../utils/hooks/useEditDeleteModal'
import ModalPaymentMethodSellTicket from './ModalPaymentMethodSellTicket'
import ModalPaymentMethodSellTicketRefund from './ModalPaymentMethodSellTicketRefund'

export interface ModalPaymentMethodTPVProps  {
    setOpenModal: SetEditDeleteModalTy
    openModal?: UseEditDeleteModalProps
    url: string
    completeData: TPVOrderData
    beforeSubmit?: (url: string, navigateUrl: string, extraProps?: TwinDictionary | undefined) => Promise<void>
    allRowData?: RowData
    onSubmit?: () => void
    isRefund?: boolean
    isReservedRefund?: boolean
    translations?: {
        textButton: string;
        textTotal: string;
    }
}

const ModalPaymentMethodTPV: React.FC<ModalPaymentMethodTPVProps> = ({ isRefund, ...rest }) => {
    if (isRefund) {
        return <ModalPaymentMethodSellTicketRefund {...rest}  />
    }
    return <ModalPaymentMethodSellTicket {...rest}  />
}


export default ModalPaymentMethodTPV
